module.exports = __webpack_public_path__ + "img/jpg.a11ade50.svg";